/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { tenantsList } from "../../funcs/tenantsList.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .GetApiLeadScraperMicroserviceApiV1OrganizationTenantsOrganizationIdRequest$inboundSchema,
};

export const tool$tenantsList: ToolDefinition<typeof args> = {
  name: "tenants_list",
  description: `List all tenants

Retrieves a list of all tenants in the system`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await tenantsList(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
